
import { Card, CardContent } from "@/components/ui/card";

const AdPanel = () => {
  return (
    <div className="w-full bg-carbon border-b border-ice-white/10 sticky top-0 z-50" style={{ height: 'calc(100vh / 7)' }}>
      <Card className="h-full rounded-none border-0 bg-carbon">
        <CardContent className="h-full flex items-center justify-center p-2">
          <div className="text-center">
            <p className="text-sm text-ice-white/70 mb-1">Advertisement</p>
            <div className="bg-carbon/50 rounded-lg p-4 min-h-16 flex items-center justify-center border border-ice-white/10">
              <p className="text-xs text-ice-white/50">Your Ad Could Be Here</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdPanel;
